export default "__VITE_ASSET__DDJiULht__"